/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import * as THREE from 'three'
import React, {useCallback, useEffect, useLayoutEffect, useRef, useState} from 'react'
import {Html, useGLTF, useTexture} from '@react-three/drei'
import {GLTF} from 'three/examples/jsm/loaders/GLTFLoader'
import {IS_MOBILE, ROOT_PATH_PREFIX} from "../../../common/const";
import {disposeScene} from "../../../../utils/disposeScene";
import {useLoader} from "@react-three/fiber";
import {GLTFLoader} from "three-stdlib";
import {GLTFResult_ObjetModernProducts} from "./Product_Harvester";
import {useObjetColorStore} from "../../../../stores/objetProductStore";
import {useModalTutorial} from "../../../../stores/modalStore";
import {animated, useSpring} from "@react-spring/web";
import {air_care_aero_data, Objet_ColorCategoryType} from "../../../../api/products/objetProductsData";
import {LangLabelType} from "../../../../api/lang/langData";
import {TextureLoader} from "three";
import {easeCubicInOut} from "d3-ease";
import {a} from "@react-spring/three";
import ObjetProductContainer3D from "../../../common/ObjetProductContainer3D";
import {useKTXLoader} from "../../../../utils/useKTXLoader";
import ObjetPlusButton from "../../ObjetPlusButton";
import useHistoryStore from "../../../../stores/historyStore";


const GLTF_URL = IS_MOBILE ?
    (ROOT_PATH_PREFIX + '/RP/rooms/modern/m/modern_products_ktx2.glb') :
    (ROOT_PATH_PREFIX + '/RP/rooms/modern/modern_products_ktx2.glb');
const LIGHT_MAP_URL = IS_MOBILE ?
    (ROOT_PATH_PREFIX + '/RP/rooms/natural/m/map/Lightmap_AeroTower_modern.jpg') :
    (ROOT_PATH_PREFIX + '/RP/rooms/natural/map/Lightmap_AeroTower_modern.jpg');

const COLOR_0_URL = IS_MOBILE ?
    (ROOT_PATH_PREFIX + '/RP/rooms/natural/m/map/aero_tower/white_mat_body_BaseColor.jpg') :
    (ROOT_PATH_PREFIX + '/RP/rooms/natural/map/aero_tower/white_mat_body_BaseColor.jpg');
const COLOR_1_URL = IS_MOBILE ?
    (ROOT_PATH_PREFIX + '/RP/rooms/natural/m/map/aero_tower/red_Bake1_pbr_diffuse.jpg') :
    (ROOT_PATH_PREFIX + '/RP/rooms/natural/map/aero_tower/red_Bake1_pbr_diffuse.jpg');
const COLOR_2_URL = IS_MOBILE ?
    (ROOT_PATH_PREFIX + '/RP/rooms/natural/m/map/aero_tower/green_Bake1_pbr_diffuse.jpg') :
    (ROOT_PATH_PREFIX + '/RP/rooms/natural/map/aero_tower/green_Bake1_pbr_diffuse.jpg');
const COLOR_3_URL = IS_MOBILE ?
    (ROOT_PATH_PREFIX + '/RP/rooms/natural/m/map/aero_tower/brown_Bake1_pbr_diffuse.jpg') :
    (ROOT_PATH_PREFIX + '/RP/rooms/natural/map/aero_tower/brown_Bake1_pbr_diffuse.jpg');


export default function Model(props: JSX.IntrinsicElements['group']) {
    const group = useRef<THREE.Group>()
    const {nodes, materials, scene} = useKTXLoader(GLTF_URL) as GLTFResult_ObjetModernProducts
    const lightmapTex = useLoader(TextureLoader, LIGHT_MAP_URL);

    const colorTextures = useTexture([COLOR_0_URL, COLOR_1_URL, COLOR_2_URL, COLOR_3_URL]);

    const colorCategory = useObjetColorStore(state => state.air_care_aero_ColorCategory);
    const colorLabel = useObjetColorStore(state => state.air_care_aero_ColorLabel);

    const isOpenTutorial = useModalTutorial(state => state.isOpen);

    const [isSet, setIsSet] = useState(false);

    const [spring, animate] = useSpring(() => ({
        from: {
            opacity: 0
        }
    }));

    const changeTexture = useCallback((materialName: string, colorCategory?: Objet_ColorCategoryType, colorLabel?: LangLabelType, isFirst: boolean = false) => {

        if (colorCategory === 'Nature') {
            if (colorLabel === 'objet_color_cream_white') {
                if (!isFirst) setIsSet(true);
                colorTextures[0].flipY = false;
                colorTextures[0].encoding = THREE.sRGBEncoding;
                colorTextures[0].needsUpdate = true;
                materials[`${materialName}`].map = colorTextures[0];
            } else if (colorLabel === 'objet_color_redwood') {
                if (!isFirst) setIsSet(true);
                colorTextures[1].flipY = false;
                colorTextures[1].encoding = THREE.sRGBEncoding;
                colorTextures[1].needsUpdate = true;
                materials[`${materialName}`].map = colorTextures[1];
            } else if (colorLabel === 'objet_color_green') {
                if (!isFirst) setIsSet(true);
                colorTextures[2].flipY = false;
                colorTextures[2].encoding = THREE.sRGBEncoding;
                colorTextures[2].needsUpdate = true;
                materials[`${materialName}`].map = colorTextures[2];
            } else if (colorLabel === 'objet_color_clay_brown') {
                if (!isFirst) setIsSet(true);
                colorTextures[3].flipY = false;
                colorTextures[3].encoding = THREE.sRGBEncoding;
                colorTextures[3].needsUpdate = true;
                materials[`${materialName}`].map = colorTextures[3];
            }
        }
    }, []);

    useLayoutEffect(() => {
        changeTexture('mat_body.005', colorCategory, colorLabel);
    }, [colorCategory, colorLabel]);

    useEffect(() => {
        return () => {
            disposeScene(scene);
            lightmapTex.dispose();
            for (let i = 0; i < colorTextures.length; i++) {
                colorTextures[i].dispose();
            }
            useLoader.clear(TextureLoader, LIGHT_MAP_URL);
            useLoader.clear(TextureLoader, [COLOR_0_URL, COLOR_1_URL, COLOR_2_URL, COLOR_3_URL]);
        }
    }, []);

    useEffect(() => {
        animate({cancel: true});
        if (!isOpenTutorial) {
            animate({
                cancel: false,
                opacity: !isSet ? 1 : 0,
                delay: 2000,
                config: {duration: 1000, easing: easeCubicInOut},
                // onRest: result => {
                //     console.log(">>>>>", result);
                // }
            });
        }
    }, [isOpenTutorial]);

    useLayoutEffect(() => {
        lightmapTex.flipY = false;
        lightmapTex.encoding = THREE.sRGBEncoding;
        lightmapTex.needsUpdate = true;

        materials["mat_body.005"].lightMap = lightmapTex;

        changeTexture("mat_body.005", "Nature", "objet_color_cream_white", true);
    }, [lightmapTex]);

    const pathname = useHistoryStore(state => state.pathname);

    return (
        <group ref={group} {...props} dispose={null}>
            <mesh
                geometry={nodes.aero_tower.geometry}
                material={materials['mat_body.005']}
                position={[-0.9893, 0.1073, 3.9134]}
                rotation={[-Math.PI, 1.3637, -Math.PI]}
            />

            <mesh
                geometry={nodes.aero_tower.geometry}
                position={[-0.9893, 0.1073, 3.9134]}
                scale={1.07}
                visible={!isSet}
            >
                {/* @ts-ignore */}
                <a.meshBasicMaterial color={"#fff"} depthTest={true} depthWrite={true} transparent={true}
                                     opacity={spring.opacity}/>
                <ObjetPlusButton position={[0, 0.7, 0]} scale={0.8} visible={!(isSet)} opacity={spring.opacity}
                                 color={pathname.indexOf('/air_care_aero') > -1 ? '#be1e42' : '#000'}/>
            </mesh>

            <ObjetProductContainer3D
                args={[0.25, 1.1, 0.25]}
                position={[-0.9893, 0.7, 3.9134]}
                data={air_care_aero_data}
                showDebug={false}
                cameraTargetPos={[2, 0.5, 0]}
            />
        </group>
    )
}
